module.exports = __webpack_public_path__ + "img/achat-carte.202e823e.png";